function scoreColor(score) {
  if (score >= 75) return '#639922'
  if (score >= 50) return '#BA7517'
  return '#E24B4A'
}

export default function ScoreBar({ score }) {
  const color = scoreColor(score)
  return (
    <div style={styles.wrap}>
      <div style={styles.track}>
        <div style={{ ...styles.fill, width: `${score}%`, background: color }} />
      </div>
      <span style={{ ...styles.label, color }}>{score}</span>
    </div>
  )
}

const styles = {
  wrap: { display: 'flex', alignItems: 'center', gap: 6 },
  track: {
    height: 5,
    borderRadius: 3,
    background: '#e0dfd8',
    flex: 1,
    overflow: 'hidden',
  },
  fill: { height: '100%', borderRadius: 3 },
  label: { fontSize: 11, fontWeight: 500, minWidth: 24 },
}
